import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import { Modal } from 'containers/misc'
import { WizardSteps, WizardStep, Button } from 'components/misc'
import { modal } from 'redux/modules/app'
import { ACTIVITY_STATE_CATEGORIES, PROGRESS_STATES } from '../../../constants/enums'

@connect(
  ({ app }) => ({
    globalLoading: app.misc.loading
  }),
  { modal }
)
class StateSwitcher extends Component {
  static propTypes = {
    id: PropTypes.number,
    modal: PropTypes.func.isRequired,
    states: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    changeState: PropTypes.func.isRequired,
    globalLoading: PropTypes.bool,
    ModalContent: PropTypes.node,
    validationData: PropTypes.object,
    stateType: PropTypes.string
  }

  state = {
    newState: {}
  }

  key = uuid.v1()

  handleStatusChange = newState => {
    this.setState({ newState }, () => {
      this.props.modal(`modal-change-activity-status-${this.key}`)
    })
  }

  render() {
    const {
      states,
      state,
      changeState,
      id,
      globalLoading,
      ModalContent,
      validationData,
      stateType
    } = this.props

    const { newState } = this.state

    const keys = Object.keys(states)

    const stateTypeCond = stateType && (stateType === ACTIVITY_STATE_CATEGORIES.activity.id || stateType === ACTIVITY_STATE_CATEGORIES.award.id)

    // activity conditions

    const forbiddenActivityStateCond = get(state, 'value') !== PROGRESS_STATES.awardOfficeSignoff.id || get(state, 'value') !== PROGRESS_STATES.awardLeaderSignoff.id

    const activityAssessmentCond = (get(newState, 'state') === PROGRESS_STATES.awardLeaderSignoff.id && forbiddenActivityStateCond && !get(validationData, 'isAssessmentPositive') && stateTypeCond)

    const activityCompletedCond = (get(newState, 'state') === PROGRESS_STATES.activityAssessment.id && forbiddenActivityStateCond && !get(validationData, 'isCompleted'))
    // award conditions
    const permittedAwardNewStateCond = get(newState, 'state') === PROGRESS_STATES.awardLeaderSignoff.id

    const forbiddenAwardStateCond = get(state, 'value') !== PROGRESS_STATES.awardOfficeSignoff.id || get(state, 'value') !== PROGRESS_STATES.awardLeaderSignoff.id

    const awardAssessmentCond = (permittedAwardNewStateCond && forbiddenAwardStateCond && !get(validationData, 'isAssessmentPositive') && stateTypeCond)

    const awardCompletedCond = (permittedAwardNewStateCond && forbiddenAwardStateCond && !get(validationData, 'isCompleted'))
    // conditions
    const missingAssessmentCond = activityAssessmentCond || awardAssessmentCond

    const warningsStateHoursCountCond = activityCompletedCond || awardCompletedCond


    let Content = (
      <div>
        <h2 className="text--center" style={{ fontWeight: 500 }}>
          <FormattedHTMLMessage
            id="states.change_to_state"
            defaultMessage="Change to <strong>{state}</strong> state"
            values={{ state: newState.label }}
          />
        </h2>

        {missingAssessmentCond && <div className="text--center" style={{ color: '#f70c4d', paddingBottom: 10 }}>
          <FormattedHTMLMessage
              id="states.change_to_state_warning_missing_assessment"
              defaultMessage="WARNING: The assessment has not been added. Do you still want to proceed?"
              values={{ state: newState.label }}
          />
          </div>}
        {warningsStateHoursCountCond && stateTypeCond && <div className="text--center" style={{ color: '#f70c4d', paddingBottom: 10 }}>
          <FormattedHTMLMessage
              id="states.change_to_state_warning_missing_hours_to_complete"
              defaultMessage="WARNING: The minimum hours required have not been recorded. Do you still want to proceed?"
              values={{ state: newState.label }}
          />
          </div>}

        <div className="row">
          <div className="col-xs-6">
            <Button
              secondary
              type="button"
              onClick={() => this.props.modal(null)}
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              type="button"
              isLoading={globalLoading}
              onClick={() => changeState(id, newState.state)}
              intlKey="button.change"
            >
              Change
            </Button>
          </div>
        </div>
      </div>
    )

    if (ModalContent) {
      Content = ModalContent
    }

    return (
      <div>
        <WizardSteps>
          {keys.map(key => {
            return (
              <WizardStep
                key={get(states[key], 'id')}
                title={get(states[key], 'label')}
                intlKey={get(states[key], 'intlKey')}
                state={get(states[key], 'id')}
                activeState={state.value}
                onStatusChange={this.handleStatusChange}
                hasSeparator={get(states[key], 'hasSeparator')}
                isLast={get(states[key], 'isLast')}
                disabled={
                  states[state.value] &&
                    states[state.value].disabledStates.some(
                      item => item === states[key].id || item === 'DISABLED'
                    )
                }
              >
                {states[key].content}
              </WizardStep>
            )
          })}
        </WizardSteps>
        <Modal id={`modal-change-activity-status-${this.key}`} customActions>
          {Content}
        </Modal>
      </div>
    )
  }
}

export default StateSwitcher
